import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '~/ui-components';

export const CorrectQuizQuestionIcon = () => <Icon type={faCheck} color="green" />;
